import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import ButtonsUndoRedo from '../../../components/Editor/ButtonsUndoRedo';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			history: { undos, redos },
			editableTextFields,
			activeItem: { id, page },
		},
	} = state;

	return {
		isUndoDisabled: undos.length === 0,
		isRedoDisabled: redos.length === 0,
		isSomeTextFieldActive: id && page && !!editableTextFields[page][id],
	};
};

export default connect(mapStateToProps)(ButtonsUndoRedo);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ButtonsUndoRedo/index.tsx